import React from 'react';

import tilted_earth from '../images/tilted_earth_text.jpg';
import email from '../images/icons/email.svg';
import facebook from '../images/icons/facebook.svg';
import youtube from '../images/icons/youtube.svg';
import twitter from '../images/icons/twitter.svg';

const Footer = () => (
  <div id="footer">
    <div className="content">
      <div className="icons">
        <a href="mailto:contact@legacyofthestars.com">
          <img src={email} />
        </a>
        <a href="https://www.facebook.com/LegacyOfTheStars/">
          <img src={facebook} />
        </a>
        <a href="https://www.youtube.com/channel/UC-EUhaQfzvEmVLLG0x0cGJg">
          <img src={youtube} />
        </a>
        <a href="https://twitter.com/LotS_Game">
          <img src={twitter} />
        </a>
      </div>
      <img src={tilted_earth} />
    </div>
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/layouts/footer.js